import { createEntityAdapter } from "@reduxjs/toolkit"
import { createAppSlice } from "../../app/createAppSlice"

//entity: {  
//     id: path,
//     pretrackedversion: number,
//     pretrackedvalue: getValueFromPath(oldResourceJson, path),
//     savedversion: number (preTrackedVersion + 1),
//     savedvalue: getValueFromPath(newResourceJson, path),
//     versionlog: [[newestVersion, userName],[newestVersion, userName]]
//     comments: [[dateTime, userName, comment],[dateTime, userName, comment]],
//     status: "active" or "accept" or "accepted" or "reject" or "rejected"

//key uses: View/Edit Track Changes Modal

const trackChangesAdapter = createEntityAdapter({
    sortComparer: (b, a) => {
        if (b?.id && a?.id && b.id !== a.id) {
            return b.id.localeCompare(a.id)
        } else {
            return 0
        }
    }
})

const initialState = trackChangesAdapter.getInitialState({
    status: 'idle'
})

const trackChangesSlice = createAppSlice({
    name: "trackChanges",
    initialState,
    reducers: create => ({
        trackedChangeAdded: create.preparedReducer(
            (sectionBody) => {
                return {
                    payload: {
                        id: sectionBody.id,
                        pretrackedversion: sectionBody.pretrackedversion,
                        pretrackedvalue: sectionBody.pretrackedvalue,
                        savedversion: sectionBody.savedversion,
                        savedvalue: sectionBody.savedvalue,
                        versionlog: sectionBody.versionlog,
                        comments: sectionBody.comments,
                        status: sectionBody.status
                    }
                };
            },
            trackChangesAdapter.addOne
        ),
        trackedChangeUpdated: create.reducer((state, action) => {
            const { id, pretrackedversion, pretrackedvalue, savedversion, savedvalue, versionlog, comments, status } = action.payload;
            trackChangesAdapter.updateOne(state,
                {
                    id, changes: {
                        pretrackedversion, pretrackedvalue, savedversion, savedvalue, versionlog, comments, status
                    }
                })
        }),
        loadTrackedChanges: create.reducer((state, action) => {
            trackChangesAdapter.setAll(state, action.payload.trackChanges);
            state.status = "succeeded";
        })
    }),
    selectors: {
        selectTrackChangesStatus: trackChanges => trackChanges.status
    }
})

export const { trackedChangeAdded, trackedChangeUpdated, loadTrackedChanges } = trackChangesSlice.actions

export const { selectTrackChangesStatus } = trackChangesSlice.selectors

export const {
    selectAll: selectAllTrackedChanges,
    selectById: selectTrackedChangeById,
} = trackChangesAdapter.getSelectors(state => state.trackChanges)

export default trackChangesSlice